import { PawPrint, Sparkles } from "lucide-react";
import shareCardBg from "@/assets/share-card-bg.png";

interface Props {
  backgroundDataUrl?: string;
}

export const StoryCzteryLapyUrgent2 = ({ backgroundDataUrl }: Props) => {
  const bgImage = backgroundDataUrl || shareCardBg;

  return (
    <div
      style={{
        width: "1080px",
        height: "1920px",
        fontFamily: "'Nunito', sans-serif",
        position: "relative",
        overflow: "hidden",
        backgroundColor: "#1a3a2a",
      }}
    >
      <img
        src={bgImage}
        alt=""
        draggable={false}
        data-export-bg="true"
        loading="eager"
        decoding="sync"
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          objectFit: "cover",
          zIndex: 0,
        }}
      />

      {/* Top label */}
      <div
        style={{
          position: "absolute",
          top: "320px",
          left: "80px",
          right: "80px",
          display: "flex",
          alignItems: "center",
          gap: "14px",
          zIndex: 3,
        }}
      >
        <div
          style={{
            background: "#E8763A",
            color: "#FFFFFF",
            padding: "10px 22px",
            borderRadius: "999px",
            fontSize: "26px",
            fontWeight: 800,
            letterSpacing: "2px",
          }}
        >
          PILNE
        </div>
        <span style={{ fontSize: "26px", fontWeight: 700, color: "#FFFFFF", letterSpacing: "1px" }}>
          ZBIÓRKA TRWA
        </span>
      </div>

      {/* Big bento card */}
      <div
        style={{
          position: "absolute",
          top: "440px",
          left: "80px",
          right: "80px",
          background: "rgba(255,255,255,0.98)",
          borderRadius: "44px",
          padding: "60px 56px",
          boxShadow: "0 24px 70px rgba(0,0,0,0.3)",
          zIndex: 2,
        }}
      >
        {/* Heart emoji + headline */}
        <div style={{ marginBottom: "36px" }}>
          <div style={{ fontSize: "100px", lineHeight: 1, marginBottom: "16px" }}>🆘</div>
          <p
            style={{
              fontSize: "78px",
              fontWeight: 800,
              color: "#2D5A3D",
              lineHeight: 1.05,
              margin: 0,
            }}
          >
            Pieski potrzebują
          </p>
          <p
            style={{
              fontSize: "78px",
              fontWeight: 800,
              color: "#E8763A",
              lineHeight: 1.05,
              margin: "4px 0 0",
            }}
          >
            naszej pomocy
          </p>
        </div>

        {/* Divider */}
        <div
          style={{
            height: "3px",
            background: "linear-gradient(90deg, #2D5A3D 0%, transparent 100%)",
            marginBottom: "32px",
            borderRadius: "2px",
          }}
        />

        {/* Body text */}
        <p
          style={{
            fontSize: "32px",
            fontWeight: 600,
            color: "#3D4A42",
            lineHeight: 1.45,
            margin: "0 0 36px",
          }}
        >
          Stowarzyszenie prosi o wsparcie zbiórki - karma, leki i opieka dla podopiecznych.
        </p>

        {/* Shelter mini-card */}
        <div
          style={{
            background: "linear-gradient(135deg, #F0F7F2 0%, #E0EDE5 100%)",
            borderRadius: "24px",
            padding: "28px 32px",
            display: "flex",
            alignItems: "center",
            gap: "20px",
            border: "2px solid #C8DDD0",
          }}
        >
          <div
            style={{
              width: "84px",
              height: "84px",
              borderRadius: "20px",
              background: "linear-gradient(135deg, #2D5A3D 0%, #4E8A6E 100%)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
            }}
          >
            <PawPrint style={{ width: "44px", height: "44px", color: "#FFFFFF" }} />
          </div>
          <div style={{ display: "flex", flexDirection: "column" }}>
            <span style={{ fontSize: "32px", fontWeight: 800, color: "#2D5A3D", lineHeight: 1.15 }}>
              Stowarzyszenie Cztery Łapy
            </span>
            <span style={{ fontSize: "26px", fontWeight: 600, color: "#5D7A6B", marginTop: "4px" }}>
              Olecko, woj. warmińsko-mazurskie
            </span>
          </div>
        </div>
      </div>

      {/* Bottom CTA */}
      <div
        style={{
          position: "absolute",
          bottom: "140px",
          left: "80px",
          right: "80px",
          zIndex: 2,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "20px",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "14px",
            background: "linear-gradient(135deg, #E8763A 0%, #D85F1F 100%)",
            borderRadius: "999px",
            padding: "26px 52px",
            boxShadow: "0 14px 40px rgba(216,95,31,0.5)",
          }}
        >
          <Sparkles style={{ width: "36px", height: "36px", color: "#FFFFFF" }} />
          <span style={{ fontSize: "38px", fontWeight: 800, color: "#FFFFFF" }}>
            Wesprzyj zbiórkę
          </span>
        </div>
        <p style={{ fontSize: "26px", fontWeight: 700, color: "#FFFFFF", margin: 0, textShadow: "0 2px 8px rgba(0,0,0,0.5)" }}>
          → fb.com/adoptujpsa.olecko
        </p>
      </div>
    </div>
  );
};
